import { QuoteStatus } from '@lombok/shared';
import type { QuoteStatus as QuoteStatusType } from '@lombok/shared';

/**
 * Spanish labels + groupings for the cotizaciones slice. Stored values stay
 * snake_case (from @lombok/shared); only what users see is Spanish. The status
 * pill colors + labels live in StatusPill (shared `quote` map) — these are the
 * quote-specific extras: the list filter tabs.
 */

/** A list filter tab: a label + the status it filters by (`undefined` = "Todas"). */
export interface QuoteStatusTab {
  label: string;
  status?: QuoteStatusType;
}

/**
 * Filter tabs for the Cotizaciones list. Order mirrors the lifecycle so the most
 * actionable states (enviada, aceptada) sit up front. `expired` is not given its
 * own tab (it is a passive timeout, surfaced via the status pill on each row),
 * matching the slice spec's tab set.
 */
export const QUOTE_STATUS_TABS: readonly QuoteStatusTab[] = [
  { label: 'Borrador', status: QuoteStatus.DRAFT },
  { label: 'Enviada', status: QuoteStatus.SENT },
  { label: 'Aceptada', status: QuoteStatus.ACCEPTED },
  { label: 'Rechazada', status: QuoteStatus.REJECTED },
  { label: 'Convertida', status: QuoteStatus.CONVERTED },
];
